import { render, staticRenderFns } from "./RegisterCodeRegistrationOkasan.vue?vue&type=template&id=17646135&scoped=true&"
import script from "./RegisterCodeRegistrationOkasan.vue?vue&type=script&lang=ts&"
export * from "./RegisterCodeRegistrationOkasan.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterCodeRegistrationOkasan.vue?vue&type=style&index=0&id=17646135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17646135",
  null
  
)

export default component.exports